// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__38Wie","header":"style_header__3lEn5"};